import * as yup from 'yup';
import { ContactRole } from 'enums';
import { messages } from 'i18n';

const { requiredField, invalidEmail } = messages.formMessages;

export const schema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .when('role', {
      is: ContactRole.SubmissionBox,
      otherwise: (s) => s.required(requiredField),
    }),
  lastName: yup
    .string()
    .trim()
    .when('role', {
      is: ContactRole.SubmissionBox,
      otherwise: (s) => s.required(requiredField),
    }),
  email: yup.string().trim().email(invalidEmail).required(requiredField),
  phoneNumber: yup.string().trim(),
  role: yup.string().required(requiredField),
  title: yup.string().trim(),
});

export interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  title: string;
  role: ContactRole;
  teamProducts: string[];
}

export enum FormFieldsNames {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  TeamProducts = 'teamProducts',
  PhoneNumber = 'phoneNumber',
  Role = 'role',
  Title = 'title',
}
